var map = {
	"./Arrow_down.svg": 8015,
	"./Arrow_up.svg": 5588,
	"./Browse.svg": 9139,
	"./Delete.svg": 342,
	"./Downlod.svg": 4868,
	"./Edit.svg": 5049,
	"./Edit_old.svg": 3381,
	"./Edit_white.svg": 3226,
	"./Enquiry.svg": 776,
	"./Error.svg": 4423,
	"./Information.svg": 7293,
	"./Information_white.svg": 5935,
	"./Reset.svg": 6020,
	"./add.svg": 9718,
	"./close.svg": 3319,
	"./close_icon.svg": 1825,
	"./edit .svg": 4022,
	"./ic-outline-open-in-new.svg": 654,
	"./icon_maximize.svg": 7980,
	"./icon_minimize.svg": 3648,
	"./lat.svg": 3321,
	"./originator.svg": 7095,
	"./remove.svg": 8723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6070;